<template>
    <el-dialog v-dialogDrag class="im-dialog-shell im-dialog-shell--md" title="投诉" :visible.sync="show" :width="dialogWidth"
        :before-close="close" custom-class="complaint-dialog" top="4vh" append-to-body>
        <div class="complaint" :class="{ 'is-mobile': isMobileView }">
            <el-form class="complaint-form" :model="formData" :rules="rules" ref="form" label-position="top">
                <el-form-item label="投诉对象">
                    <div class="target-card">
                        <span class="target-name">{{ formData.targetName }}</span>
                    </div>
                </el-form-item>
                <el-form-item prop="type" label="投诉原因">
                    <el-select v-model="formData.type" placeholder="请选择原因" class="field-control">
                        <el-option v-for="item in $dict.COMPLAINT_TYPE" :key="item.val" :label="item.name"
                            :value="item.val">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="images" label="图片证据">
                    <div class="images">
                        <div v-for="(img, idx) in formData.images" :key="img.id || img.originUrl">
                            <div class="image-item" v-loading="img.loading">
                                <asset-image class="image" :src="img.thumbUrl" loading="lazy" />
                                <div class="mask">
                                    <div class="mask-actions">
                                        <i class="icon el-icon-zoom-in" @click="onFullImage(idx)"></i>
                                        <i class="icon el-icon-delete" @click="onRemoveImage(idx)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <file-upload v-show="formData.images.length < maxUploadSize" :action="'/image/upload'"
                            :maxSize="10 * 1024 * 1024"
                            :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
                            @before="onUploadBefore" @success="onUploadSuccess" @fail="onUploadFail">
                            <div class="upload-image">
                                <i class="el-icon-plus"></i>
                            </div>
                        </file-upload>
                    </div>
                    <div class="count-tip">{{ countTip }}</div>
                </el-form-item>
                <el-form-item prop="content" label="补充说明">
                    <el-input type="textarea" placeholder="请输入投诉内容" v-model="formData.content" :rows="textareaRows"
                        maxlength="512" show-word-limit resize="none"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close()" :disabled="submitting">取 消</el-button>
            <el-button type="primary" @click="submit()" :loading="submitting">提 交</el-button>
        </span>
    </el-dialog>
</template>
<script>
import AssetImage from './AssetImage.vue';
import FileUpload from './FileUpload.vue';

export default {
    name: 'complaint',
    components: { AssetImage, FileUpload },
    data() {
        return {
            maxImageId: 1,
            show: false,
            submitting: false,
            maxUploadSize: 9,
            formData: {
                type: null,
                images: [],
                content: '',
                targetName: ''
            },
            rules: {
                type: [{
                    required: true, message: '请选择投诉原因', trigger: 'change'
                }],
                content: [{
                    required: true, message: '请输入投诉内容', trigger: 'blur'
                }]
            }
        }
    },
    methods: {
        open(type, id, name) {
            this.show = true;
            this.submitting = false;
            this.formData.type = null;
            this.formData.content = '';
            this.formData.images = [];
            this.formData.targetType = type;
            this.formData.targetId = id;
            this.formData.targetName = name;
        },
        close() {
            this.submitting = false;
            this.show = false;
        },
        submit() {
            if (this.submitting) {
                return;
            }
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.submitting = true;
                this.$http({
                    url: '/complaint/initiate',
                    method: 'post',
                    data: this.formData
                }).then(() => {
                    this.$message.success("投诉已提交");
                    this.close();
                }).finally(() => {
                    this.submitting = false;
                });
            });
        },
        onUploadBefore(file) {
            if (this.formData.images.length >= this.maxUploadSize) {
                this.$message.error(`最多上传${this.maxUploadSize}张图片`);
                return;
            }
            let id = this.maxImageId++;
            let url = URL.createObjectURL(file);
            let image = {
                id: id,
                originUrl: url,
                thumbUrl: url,
                loading: true
            }
            this.formData.images.push(image);
            file.id = id;
            return true;
        },
        onUploadSuccess(data, file) {
            let image = this.formData.images.find(m => m.id == file.id);
            if (image) {
                image.originUrl = data.originUrl;
                image.thumbUrl = data.thumbUrl;
                image.loading = false;
            }
        },
        onUploadFail(data, file) {
            for (let idx in this.formData.images) {
                let image = this.formData.images[idx];
                if (image.id == file.id) {
                    this.formData.images.splice(idx, 1);
                    break;
                }
            }
        },
        onFullImage(idx) {
            this.$eventBus.$emit("openFullImage", this.formData.images[idx].originUrl);
        },
        onRemoveImage(idx) {
            this.formData.images.splice(idx, 1);
        }
    },
    computed: {
        isMobileView() {
            return this.configStore.isMobile;
        },
        dialogWidth() {
            return this.isMobileView ? '100%' : '560px';
        },
        textareaRows() {
            return this.isMobileView ? 5 : 6;
        },
        countTip() {
            return `${this.formData.images.length}/${this.maxUploadSize}`;
        }
    }
}
</script>

<style scoped lang="scss">
.complaint {
    min-height: 0;

    .complaint-form {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .target-card {
        display: flex;
        align-items: center;
        min-height: 40px;
        padding: 0 12px;
        border-radius: 8px;
        background: var(--im-control-soft-bg);
        border: 1px solid var(--im-control-border);
    }

    .target-name {
        font-size: 13px;
        font-weight: 500;
        color: var(--im-text-color);
        word-break: break-all;
    }

    .field-control {
        width: 100%;
    }

    .images {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .image-item,
    .upload-image {
        width: 96px;
        height: 96px;
        border-radius: 8px;
    }

    .image-item {
        position: relative;
        overflow: hidden;

        .image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .mask {
            display: none;
            position: absolute;
            inset: 0;
        }

        &:hover {
            .mask {
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(var(--im-black-rgb), 0.48);
                color: var(--im-text-color-white);
            }
        }
    }

    .mask-actions {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .icon {
        cursor: pointer;
        font-size: 16px;
    }

    .upload-image {
        background: var(--im-control-bg);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        border: 1px dashed var(--im-control-border);
        color: var(--im-text-color-light);
    }

    .count-tip {
        margin-top: 8px;
        color: var(--im-text-color-light);
        text-align: right;
        font-size: 12px;
        line-height: 1.2;
    }

    &.is-mobile {
        .images {
            gap: 6px;
        }

        .image-item,
        .upload-image {
            width: 84px;
            height: 84px;
            border-radius: 10px;
        }
    }
}

::v-deep .complaint-dialog {
    max-height: calc(100vh - 32px);
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &:not(.is-fullscreen) {
        width: min(560px, calc(100vw - 24px)) !important;
    }

    .el-dialog__body {
        flex: 1;
        min-height: 0;
        overflow: auto;
        padding: 12px 16px 10px;
    }

    .el-dialog__footer {
        flex-shrink: 0;
        padding: 0 16px 16px;
    }

    .el-form-item {
        margin-bottom: 12px;
    }

    .el-form-item__label {
        padding-bottom: 6px;
        line-height: 1.2;
        font-size: 12px;
        font-weight: 600;
        color: var(--im-text-color-light);
    }

    .el-textarea__inner,
    .el-input__inner {
        border-radius: 6px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .el-textarea__inner:focus,
    .el-input__inner:focus {
        border-color: var(--im-control-border-strong);
        box-shadow: 0 0 0 2px rgba(var(--im-primary-rgb), 0.08);
    }

    &.is-fullscreen {
        max-height: none;

        .el-dialog__body {
            padding: 12px;
        }
    }
}
</style>
